<canvas #canvas class="tw:absolute tw:inset-0 tw:block tw:size-full"></canvas>
